<template>
  <v-card class="wrapper table-wrapper d-flex flex-column pa-3 ma-0 gap-1">
    <AppBar
      @get-items="handleGetItems"
      @open-dialog="handleDialog"
      @name-change="handleNameChange"
      @update_value="handleVal"
      :name-p="nameParam"
      :validate="validate"
      :be-selected="beSelected"
    />
    <Table
      :loading="loading"
      :save-return="saveReturn"
      :name-param="nameParam"
      :call-refresh="refresh"
      @table-changing="handleGetFormula"
      @again-ready-to-save="handleSave"
      @update-name="handleUpdateName"
      @validation="handleValidation"
      @at-least-one-required="handleMostBeSelected"
      @call-refresh="handleChange"
    />
    <AddSalleryFactors
      :open-dialog="openDialog"
      @close-dialog="handleCloseDialog"
      @get-items="handleGetItems"
    />
    <ActionSection
      style="max-height: 80px; overflow-y: auto; flex-shrink: 0"
      class="mt-4"
      :formula="Formula"
      :loader="loading"
      @loading="handleLoading"
      @click-save-and-return="handleSaveAndReturn"
    />
  </v-card>
</template>

<script>
import AppBar from "@/views/dashboard/pages/payroll/saleryFactors/partial/AppBar.vue";
import Table from "@/views/dashboard/pages/payroll/saleryFactors/partial/Table.vue";
import ActionSection from "@/views/dashboard/pages/payroll/saleryFactors/partial/ActionSection.vue";
import AddSalleryFactors from "./partial/AddSalleryFactors.vue";

export default {
  name: "saleryFactors",
  components: {
    AppBar,
    Table,
    AddSalleryFactors,
    ActionSection,
  },
  data: () => ({
    refresh: false,
    openDialog: false,
    initialLoading: true,
    saveReturn: false,
    items: null,
    Formula: null,
    loading: false,
    validate: true,
    beSelected: false,
    nameParam: "",
  }),
  mounted() {},
  methods: {
    handleVal() {
      this.beSelected = false;
      this.validate = true;
    },
    handleMostBeSelected() {
      this.beSelected = true;
    },
    handleValidation(val) {
      this.validate = false;
    },
    handleNameChange(val) {
      this.nameParam = val;
    },
    handleUpdateName(val) {
      this.nameParam = val;
    },
    handleLoading(val) {
      this.loading = val;
    },
    handleGetFormula(val) {
      this.Formula = val;
    },
    handleSaveAndReturn() {
      this.saveReturn = true;
    },
    handleSave() {
      this.loading = false;
      this.saveReturn = false;
    },
    handleItems(val) {
      this.items = val;
    },
    handleGetItems() {
      this.refresh = true;
      this.initialLoading = false;
    },
    handleChange() {
      this.refresh = false;
    },
    handleDialog() {
      this.openDialog = true;
    },
    handleCloseDialog() {
      this.openDialog = false;
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: calc(100vh - 100px);
  width: 100%;
}
.table-wrapper {
  position: relative;
  min-height: 300px;
}
</style>
